export const scopeUploadHistoryQuery = (resource, query) =>
  resource === "carbonImports"
    ? { ...query, tab: "BULK_UPLOAD" }
    : query;
